import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CtvExportPdfAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetCtvRapor";
        super(baseUrl);
    }
    geExportPdfListe(sqId: string) {

        // var request = new ExportPdfListeRequest(sqId);
        let enRequest: IEnCtvRequest = {
            sqId: sqId,
        };
        return this.post("", enRequest, true);
    }
}
export default new CtvExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    constructor(sicilKodu: string) {

        this.sqId = sicilKodu;

    }
}
interface IEnCtvRequest {
    sqId: string
}
export { ExportPdfListeRequest };